import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntradasService {

  entradasURL = environment.apiURL+'entradas';

  constructor(private http:HttpClient) { }

  getSlide(): Observable<any>{
    const url = this.entradasURL +'/8';
    return this.http.get<any[]>(url);
   }

   getTestimonio(): Observable<any>{
    const url = this.entradasURL +'/10';
    return this.http.get<any[]>(url);
   }

}
